import { ECheckServiceStatus } from '../../../ServicePickerWidget';

import { MicrofrontEventSender } from './microfrontEventSender';
import { FVU_CHECK_SERVICE_STATUS_CHANGE_EVENT_NAME } from './constants';

export const sendCheckServiceStatusChangeEvent = (status: ECheckServiceStatus) => {
  const event = new MicrofrontEventSender(FVU_CHECK_SERVICE_STATUS_CHANGE_EVENT_NAME, status);

  event.dispatch();
};
